// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.agent.agent_session.Prompt

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { PromptEventData, PromptEventStore } from "./PromptEvent.generated";

export interface PromptData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "Prompt";
    text: string;
    in_progress: boolean;
    phase: string;
    events: PromptEventData[];
}

export class PromptStore {
    readonly _entity_class_name = "Prompt" as const;
    text: string;
    in_progress: boolean;
    phase: string;
    events: PromptEventStore[];
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: PromptData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.text = wrapEntity(data.text, transport, [...chainPath, "text"]);
        this.in_progress = wrapEntity(data.in_progress, transport, [...chainPath, "in_progress"]);
        this.phase = wrapEntity(data.phase, transport, [...chainPath, "phase"]);
        this.events = wrapEntity(data.events, transport, [...chainPath, "events"]);
        makeObservable(this, {
            text: observable,
            in_progress: observable,
            phase: observable,
            events: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async push_event(event: PromptEventData): Promise<any> {
        return callRpc(this._transport, this._chainPath, "push_event", [event], {});
    }
}

registerEntity("Prompt", PromptStore);
